import { get, minBy, maxBy } from 'lodash';
import { SerializedScreenSize } from 'lib/ScreenSize';
import classNames from 'classnames';

interface Props {
  className?: string;
  load?: boolean;
  placeholderSize: number[];
  isShown: boolean;
  screenSizes: Array<SerializedScreenSize>;
  elementId?: string;
}

export default function Container({
  className,
  elementId,
  placeholderSize,
  isShown,
  screenSizes,
}: Props): JSX.Element {
  // Find the widest possible range of device screen widths that the ad
  // could be shown in, according to the screenSizes array
  const minWidthToShowPlaceholder = get(minBy(screenSizes, 'minWidth'), 'cssMinWidth') || '0px';

  const maxWidthToShowPlaceholder =
    get(maxBy(screenSizes, 'maxWidth'), 'cssMaxWidth') || '9999999px';

  return (
    <div className={classNames(className, 'ad')} id={elementId} data-testid="ad">
      <style jsx>{`
        .ad {
          min-width: ${placeholderSize[0]}px;
          min-height: ${placeholderSize[1]}px;
          display: none;
          justify-content: center;
        }

        /*
        Placeholder sizing so that the ad reserves appropriate space for itself
        until loading, so that the page doesn't jump around.
        Media query makes sure that it's only shown on screens that the ad itself
        could load in
        */
        @media (min-width: ${minWidthToShowPlaceholder}) and (max-width: ${maxWidthToShowPlaceholder}) {
          .ad {
            display: ${isShown ? 'flex' : 'none'};
          }
        }
      `}</style>
    </div>
  );
}
